import React, { Component } from 'react';
import ImageBW from '../../ImageBoundsWrapper';
import Modal from '../../JSModal';
import theme from 'shared/assets/style/theme';
import ENVIRONMENT_VARIABLES from 'shared/utils/environmentVariables';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { termsModalHeaderfontSizeCalc } from 'shared/utils/fontSizeCalculator';
import { onPressHelp } from 'shared/utils/redirectionHelp';
import { ThemeContext } from 'styled-components';
import LinkText from '../../LinkText/LinkText';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { isIPadMini, pwaStyleAdapter } from '../../../utils/mobileSupported';
import { isTablet } from 'react-device-detect';

export default class TermsModalWrapper extends Component {
  _style = {
    modal: {
      width: '100vw',
      height: '100dvh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0 35vmin',
    },
    modalContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: isTablet && !isIPadMini ? '80vh' : '70vh',
      width: '100%',
      marginTop: '-1vw',
      marginBottom: '-1vw',
    },
    header: {
      width: '100%',
      height: isTablet ? '9%' : '14%',
    },
    headerContent: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 5vmin',
    },
    title: {
      fontSize: '29px',
      fontWeight: '600',
      color: theme.palette.common[1],
      textTransform: 'uppercase',
    },
    body: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      padding: '0 2vmin',
    },
    titleHolder: {
      position: 'absolute',
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      padding: '0 5vmin',
      top: 0,
      right: 0,
      left: 0,
      bottom: 0,
      zIndex: 0,
    },
    linkText: {
      fontSize: isTablet ? pwaStyleAdapter(17) : pwaStyleAdapter(15),
      fontWeight: 600,
    },
  };

  render() {
    const themeContext = this.context;
    const {
      isVisible,
      closeModal,
      title,
      zIndex,
      children,
      modalStyle,
      modalContainerStyle,
      modalMainBodyStyle,
      headerStyle = {},
      headerImageStyle = {},
      bodyStyle,
      titleStyle,
      disableClose,
      hideCloseBtn,
      removeRightPart,
      removeLeftPart,
    } = this.props;

    return (
      <Modal
        isVisible={isVisible}
        zIndex={zIndex}
        style={modalStyle ? modalStyle : this._style.modal}
        className="terms-modal"
        onBackButtonPress={closeModal}
        modalMainBodyStyle={modalMainBodyStyle}
        customBackground
        disableBackDismiss={disableClose}
        hideCloseButton={hideCloseBtn}
        themeStyle={themeContext.TermsModalWrapper.Modal}
        modalMainBodyClassName={'terms-modal'}
      >
        <div className="TermsModal" style={modalContainerStyle ? modalContainerStyle : this._style.modalContainer}>
          <div style={{ ...this._style.header, ...headerStyle }}>
            <ImageBW
              source={assetSource(ASSET_KEY.FULL_MODAL_HEADER)}
              ibw={require(asset`full-modal-header.ibw`)}
              style={{ ...themeContext.TermsModalWrapper.HeaderImage, ...headerImageStyle }}
            >
              <div style={this._style.headerContent}>
                <div
                  style={{ cursor: 'pointer', zIndex: 1 }}
                  onClick={!disableClose && !removeLeftPart ? closeModal : undefined}
                >
                  {!disableClose && !removeLeftPart && (
                    <LinkText customStyle={{ ...this._style.linkText, textAlign: 'left' }} underline={false}>
                      {getText(TEXT_KEY.DECLINE)}
                    </LinkText>
                  )}
                </div>
                <div style={this._style.titleHolder}>
                  <p
                    style={{
                      ...(titleStyle ? titleStyle : this._style.title),
                      ...(!!title && termsModalHeaderfontSizeCalc(title)),
                    }}
                    className={`termsGradientText ${ENVIRONMENT_VARIABLES.APPLICATION_TARGET}`}
                    data-label={(!!title && title) || ''}
                  >
                    {(!!title && title) || ''}
                  </p>
                </div>
                <div style={{ cursor: 'pointer', zIndex: 1 }} onClick={!removeRightPart && onPressHelp}>
                  {!removeRightPart && (
                    <LinkText customStyle={this._style.linkText} underline={false}>
                      {getText(TEXT_KEY.NEED_HELP)}
                    </LinkText>
                  )}
                </div>
              </div>
            </ImageBW>
          </div>
          <div style={bodyStyle ? bodyStyle : this._style.body}>
            {children}
          </div>
        </div>
      </Modal>
    );
  }
}

TermsModalWrapper.defaultProps = {
  hideCloseBtn: false,
};

TermsModalWrapper.contextType = ThemeContext;
